import React, { Component } from "react";
import PropTypes from "prop-types";
import Styles from "./direction-overlay.module.scss";

import compassIcon from "./compass.svg";

const contextTypes = {
    viewport: PropTypes.object,
    isDragging: PropTypes.bool,
};

const ICON_SIZE = 20;

export default class DirectionOverlay extends Component {
    render() {
        const { viewport } = this.context;
        const { width, height } = viewport;
        const pixelRatio = window.devicePixelRatio || 1;

        const angle = -viewport.bearing;
        const x = ICON_SIZE / 2;
        const y = height - (ICON_SIZE / 2) - ICON_SIZE;

        const transformOriginX = x + (ICON_SIZE / 2);
        const transformOriginY = y + (ICON_SIZE / 2);

        return (
            <svg
                width={width * pixelRatio}
                height={height * pixelRatio}
                style={{
                    width: `${width}px`,
                    height: `${height}px`,
                    position: "absolute",
                    pointerEvents: "none",
                    left: 0,
                    top: 0,
                }}
            >
                <image
                    className={Styles.compassIcon}
                    xlinkHref={compassIcon}
                    height={ICON_SIZE}
                    width={ICON_SIZE}
                    x={x}
                    y={y}
                    style={{
                        transform: `rotate(${angle}deg)`,
                        transformOrigin: `${transformOriginX}px ${transformOriginY}px`,
                    }}
                />
            </svg>
        );
    }
}

DirectionOverlay.displayName = "DirectionOverlay";
DirectionOverlay.contextTypes = contextTypes;



// WEBPACK FOOTER //
// ./src/components/direction-overlay/direction-overlay.js